import { render, staticRenderFns } from "./news-details.vue?vue&type=template&id=8fc86c26&scoped=true&"
import script from "./news-details.vue?vue&type=script&lang=js&"
export * from "./news-details.vue?vue&type=script&lang=js&"
import style0 from "./news-details.vue?vue&type=style&index=0&id=8fc86c26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc86c26",
  null
  
)

export default component.exports